// extracted by mini-css-extract-plugin
export default {"container":"bnxuzh","logoContainer":"LmB9oo","logo":"_9Ouxs","formContainer":"qJFfAf","submitButton":"nQHTFB"};